// extracted by mini-css-extract-plugin
export var aboveInput = "_nl-0";
export var actionButton = "_nl-5";
export var actionButtonContainer = "_nl-1";
export var actionIcon = "_nl-6";
export var aiInfoContainer = "_nl-2";
export var attachmentWrapper = "_nl-7";
export var bold = "_nl-3";
export var checkIcon = "_nl-8";
export var clickingRecipientBar = "_nl-11";
export var commentThreadSwitch = "_nl-a";
export var draftImage = "_nl-b";
export var draftImageContainer = "_nl-c";
export var draftImages = "_nl-e";
export var editButton = "_nl-g";
export var editor = "_nl-f";
export var editorContainer = "_nl-y";
export var editorErrorTooltipWrapper = "_nl-9";
export var headerDivider = "_nl-h";
export var icon = "_nl-i";
export var info = "_nl-j";
export var internal = "_nl-n";
export var internalDivider = "_nl-k";
export var internalMessage = "_nl-l";
export var messageInputCard = "_nl-m";
export var messageInputForm = "_nl-o";
export var messageInputFormInternal = "_nl-p";
export var options = "_nl-q";
export var publicMessageCustomer = "_nl-s";
export var publicMessageMerchant = "_nl-r";
export var removeImageButton = "_nl-d";
export var replyButtons = "_nl-t";
export var showSignatureButton = "_nl-u";
export var spinner = "_nl-v";
export var verticalButtonDivider = "_nl-4";
export var visibilitySelector = "_nl-w";
export var warning = "_nl-x";
export var wrappingText = "_nl-z";
export var writingInternalNoteTopBorder = "_nl-10";